import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {EDepartmentActions, GetDepartments, GetDepartmentsSuccess, PostDepartment,} from '@app/core/store/actions/department.actions';
import {ShiftService} from '@app/modules/shared/services/shift.service';
import {Department} from '@app/core/models/department.model';
import {DepartmentService} from '@app/core/services/api/department.service';

@Injectable()
export class DepartmentEffects {

	@Effect()
	public onGetDepartments$ = this.actions$.pipe(
		ofType<GetDepartments>(EDepartmentActions.GetDepartments),
		switchMap((action: GetDepartments) => from(this.departmentService.getDepartments().pipe(
			switchMap((departments: Department[]) => [
				new GetDepartmentsSuccess(departments),
			]),
			catchError(error => of(new LoadError(error, action))),
		))),
	);

	@Effect()
	public onPostDepartment$ = this.actions$.pipe(
		ofType<PostDepartment>(EDepartmentActions.PostDepartment),
		switchMap((action: PostDepartment) => from(this.departmentService.postDepartment(action.payload)).pipe(
			switchMap((department: Department) => {
				location.reload();

				return [];
			}),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	constructor(
		private actions$: Actions,
		private shiftService: ShiftService,
		private departmentService: DepartmentService,
	) {
	}
}
